import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { ListsComponent } from './lists.component';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.lists.pageInRouting,
    data: { data: PAGES_AND_PATHS.lists },
    component: ListsComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./lists.module').then(m => m.ListsModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ListsRoutingModule { }
